// PipelineStage.tsx
import { Typography } from 'antd';
import { PipelineStageData } from './dashboardConfig';

const { Text } = Typography;

interface PipelineStageProps {
  data: PipelineStageData;
}

export const PipelineStage: React.FC<PipelineStageProps> = ({ data }) => {
  const { stage, count, countBg, countColor } = data;

  return (
    <div className="flex flex-col items-center justify-center p-2 min-w-[120px]  text-center ">
      {/* Stage Title */}
      <Text className="block text-sm font-medium text-gray-600 mb-4 whitespace-nowrap">
{/* ^^^^ Added more vertical space (mb-4) */}
        {stage}
      </Text>

      {/* Count Badge */}
      <div className={`px-9 mx-4 py-2 rounded-lg ${countBg} border border-gray-200`}>
{/* ^^^^ Added more horizontal space (mx-4) */}
        <Text className={`text-sm font-semibold ${countColor} whitespace-nowrap`}>
          {count} Deals
        </Text>
      </div>
    </div>
  );
};